module.exports = __webpack_public_path__ + "img/5.aec96042.png";